import usePrivateAxios from "@/common/api/usePrivateAxios";
import { UseQueryResult, useQuery } from "@tanstack/react-query";
import { NegotiationEquipmentCategorySummaryData } from "../types/equipmentCategorySummary.type";

type UseNegotiationEquipmentCategorySummaryType = (id?: string) => UseQueryResult<NegotiationEquipmentCategorySummaryData[], unknown>;

const useNegotiationEquipmentCategorySummary: UseNegotiationEquipmentCategorySummaryType = (id) => {
  const privateAxios = usePrivateAxios();

  return useQuery<{ data: { data: NegotiationEquipmentCategorySummaryData[] } }, unknown, NegotiationEquipmentCategorySummaryData[]>({
    queryKey: ['negotiationsEquipmentCategorySummary', id],
    queryFn: () => privateAxios.get(`/client/negotiations/${id}/equipment_category_summary`),
    select: (data) => data?.data?.data,
  });
};

export default useNegotiationEquipmentCategorySummary;
